import {createStyles, Theme} from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    '@global': {
      '::-webkit-scrollbar': {
        height: 10,
        width: 10
      },
      '::-webkit-scrollbar-thumb': {
        background: 'rgba(0,0,0,0.2)'
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: 'rgba(0,0,0,0.5)'
      },
      '::-webkit-scrollbar-track': {
        background: 'rgba(0,0,0,0.05)'
      },
      a: {
        color: theme.palette.primary.main
      },
      body: {
        color: '#000'
      }
    },
    container: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    },
    content: {
      backgroundColor: theme.palette.background.default,
      display: 'flex',
      height: '100%',
      paddingTop: 60
    },
    contentSlim: {
      paddingTop: 48
    },
    header: {
      backgroundColor: '#303030',
      border: 0,
      boxShadow: theme.shadows[2],
      color: '#fff'
    },
    headerLeft: {
      alignItems: 'center',
      display: 'flex'
    },
    headerText: {
      color: "#fff",
      textTransform: 'uppercase',
      textDecoration: 'none',
      fontSize: 18
    },
    headerRight: {
      color: '#fff'
    },
    headerToolbar: {
      justifyContent: 'space-between',
      minHeight: 60,
      paddingLeft: 12,
      paddingRight: 12
    },
    headerToolbarSlim: {
      minHeight: 48,
      maxHeight: 48
    },
    main: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      overflow: 'auto',
      transition: 'all 0.3s',
      width: 'calc(100% - 250px)'
    },
    mainMax: {
      width: 'calc(100% - 60px)'
    },
    theme: {
      color: theme.palette.primary.contrastText
    },
    logout: {
      opacity: 0.3
    },
    loaderWrapper: {
      display: 'block',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
    }
  });

export default styles;
